import { render, staticRenderFns } from "./BuildingManagement.vue?vue&type=template&id=55d71225"
import script from "./BuildingManagement.vue?vue&type=script&lang=js"
export * from "./BuildingManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports